<template>
  <div class="submit-form">
    <!-- <button class="submit-form-button" autocomplete="off" type="submit" @click.prevent="validateBtns(), validateAll()">Pošlji</button> -->
    <button class="submit-form-button" autocomplete="off" type="submit" @click.prevent="validateBtns(), validateAll()">Pošalji</button>
  </div>
</template>
<script>
import $ from 'jquery'

export default {
  data () {
    return {}
  },
  created () {
  },
  methods: {
    validateBtns () {
      for (var key in this.$store.state.buttons) {
        if (this.$store.state.buttons[key].value === null) {
          switch (key) {
            case 'emailNotice':
              this.$store.state.buttons.emailNotice.error = false
              break
          }
        } else {
          switch (key) {
            case 'emailNotice':
              this.$store.state.buttons.emailNotice.error = true
              break
          }
        }
      }
    },
    scrollTop () {
      setTimeout(() => {
        if ($('.error, .isInvalid').length) {
          $('html, body').animate({
            scrollTop: $('.error, .isInvalid').first().offset().top - 300
          }, 600)
        }
      }, 100)
    },
    validateAll () {
      this.scrollTop()
      this.$store.state.submitted = true
      // CHECK IF COMPLIENCE IS TRUE
      /*if (this.$store.state.buttons.emailNotice.error === false) {
        console.log('noup check buttons')
        return
      }*/
      /*if (!this.$store.state.form.gdpr.eNews) {
        return
      }*/
      for (var key2 in this.$store.state.validation) {
        if (this.$store.state.validation[key2] === false) {
          console.log(key2, this.$store.state.validation[key2])
          console.log('noup check fields')
          return
        }
      }

      console.log(JSON.stringify(this.$store.state.form))
      parent.postMessage('Submit', '*')
      this.$http.post('https://vega.renault.optiweb.serv.si/api/v2/vega/offer/nissan/rs', this.$store.state.form).then(response => {
        console.log(response.status)
      }, error => {
        console.log(error)
      })
      this.$router.push({name: 'ThankYou'})
    }
  }
}

/**
 * Converts year into date string by adding 0101 in front
 * @param {String} year of vehicle
 * @returns {String} date format of DDMMYYYY 
 */
function convertYearToDate(year) {
    return "0101" + year;
}
</script>

<style lang="scss" scoped>

    .submit-form-button {
        display: block;
        margin: 0 auto;
        margin-top: 50px;
    }

</style>



// WEBPACK FOOTER //
// src/components/form/Submit.vue